import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "me-2"
}
const _hoisted_5 = { class: "fs-4 fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Total workers", -1)
const _hoisted_7 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "me-2"
}
const _hoisted_10 = { class: "fs-4 fw-bolder" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Total hours", -1)
const _hoisted_12 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = {
  key: 0,
  class: "me-2"
}
const _hoisted_16 = { class: "fs-4 fw-bolder" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Total salaries", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")!
  const _component_ArrowDownIcon = _resolveComponent("ArrowDownIcon")!
  const _component_count_up = _resolveComponent("count-up")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.date)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.data && _ctx.data.users.trend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.data.users.trend == 'up')
                    ? (_openBlock(), _createBlock(_component_ArrowUpIcon, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_ArrowDownIcon, { key: 1 }))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_count_up, {
                "end-val": _ctx.data ? _ctx.data.users.result : 0
              }, null, 8, ["end-val"])
            ])
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.data && _ctx.data.hours.trend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.data.hours.trend == 'up')
                    ? (_openBlock(), _createBlock(_component_ArrowUpIcon, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_ArrowDownIcon, { key: 1 }))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_count_up, {
                "end-val": _ctx.data ? _ctx.data.hours.result : 0
              }, null, 8, ["end-val"])
            ])
          ]),
          _hoisted_11
        ]),
        (_ctx.data && _ctx.data.salaries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.salaries, (entry, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (entry.trend)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (entry.trend == 'up')
                              ? (_openBlock(), _createBlock(_component_ArrowUpIcon, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_ArrowDownIcon, { key: 1 }))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_count_up, {
                          class: "fs-4 fw-bolder",
                          options: { suffix: ` ${index}` as string },
                          "end-val": entry.result
                        }, null, 8, ["options", "end-val"])
                      ])
                    ])
                  ]),
                  _hoisted_17
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    : _createCommentVNode("", true)
}